export default __webpack_public_path__ + "static/media/shreyash_details_image.45f976df.png";